import { render, staticRenderFns } from "./TeamSize.vue?vue&type=template&id=54f773f8&scoped=true&"
import script from "./TeamSize.vue?vue&type=script&lang=js&"
export * from "./TeamSize.vue?vue&type=script&lang=js&"
import style0 from "./TeamSize.vue?vue&type=style&index=0&id=54f773f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f773f8",
  null
  
)

export default component.exports